// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function isDrawerMode() {
  return DomEl$GameDataCore.data(document.documentElement, "nav-mode") === "drawer";
}

function setPanelAria(el, open_) {
  var trigger = el.querySelector("[data-nav-flyout-trigger]");
  if (!(trigger == null)) {
    trigger.setAttribute("aria-expanded", open_ ? "true" : "false");
  }
  var panel = el.querySelector("[data-hub-games-hover-panel]");
  if (!(panel == null)) {
    panel.setAttribute("aria-hidden", open_ ? "false" : "true");
    return ;
  }
  
}

function closePanel(el) {
  var timer = el._gdcCloseTimer;
  if (timer !== undefined) {
    clearTimeout(Caml_option.valFromOption(timer));
  }
  el._gdcCloseTimer = undefined;
  el.removeAttribute("data-hub-games-open");
  setPanelAria(el, false);
}

function openPanel(el) {
  var timer = el._gdcCloseTimer;
  if (timer !== undefined) {
    clearTimeout(Caml_option.valFromOption(timer));
  }
  el._gdcCloseTimer = undefined;
  el.setAttribute("data-hub-games-open", "true");
  setPanelAria(el, true);
  if (!isDrawerMode()) {
    return ;
  }
  var back = el.querySelector("[data-nav-flyout-back]");
  if (!(back == null)) {
    queueMicrotask(function () {
          back.focus();
        });
    return ;
  }
  
}

function scheduleClose(el) {
  var timer = el._gdcCloseTimer;
  if (timer !== undefined) {
    clearTimeout(Caml_option.valFromOption(timer));
  }
  el._gdcCloseTimer = Caml_option.some(setTimeout((function () {
              closePanel(el);
            }), 150));
}

function openSheet(el) {
  Belt_Array.forEach(Array.from(document.querySelectorAll("[data-hub-games-flyout]")), (function (other) {
          if (other !== el) {
            return closePanel(other);
          }
          
        }));
  openPanel(el);
}

function focusTrigger(el) {
  var trigger = el.querySelector("[data-nav-flyout-trigger]");
  if (!(trigger == null)) {
    trigger.focus();
    return ;
  }
  
}

function mounted() {
  var self = this ;
  var el = self.el;
  var panel = el.querySelector("[data-hub-games-hover-panel]");
  if (panel == null) {
    return ;
  }
  var onEnter = function (param) {
    if (!isDrawerMode()) {
      return openPanel(el);
    }
    
  };
  var onLeave = function (param) {
    if (!isDrawerMode()) {
      return scheduleClose(el);
    }
    
  };
  el.addEventListener("mouseenter", onEnter);
  el.addEventListener("mouseleave", onLeave);
  panel.addEventListener("mouseenter", onEnter);
  panel.addEventListener("mouseleave", onLeave);
  el.addEventListener("focusin", (function (param) {
          if (!isDrawerMode()) {
            return openPanel(el);
          }
          
        }));
  el.addEventListener("focusout", (function ($$event) {
          if (isDrawerMode()) {
            return ;
          }
          var next = $$event.relatedTarget;
          if (!(next == null) && el.contains(next)) {
            return ;
          } else {
            return scheduleClose(el);
          }
        }));
  var drawerClick = function ($$event) {
    if (!isDrawerMode()) {
      return ;
    }
    var target = $$event.target;
    if (target == null) {
      return ;
    }
    var back = target.closest("[data-nav-flyout-back]");
    if (!(back == null) && el.contains(back)) {
      $$event.preventDefault();
      $$event.stopPropagation();
      closePanel(el);
      return focusTrigger(el);
    }
    var match = target.closest("[data-hub-games-hover-panel]");
    if (!(match == null)) {
      return ;
    }
    var trigger = target.closest("[data-nav-flyout-trigger]");
    if (!(trigger == null) && el.contains(trigger)) {
      $$event.preventDefault();
      $$event.stopPropagation();
      if (DomEl$GameDataCore.data(el, "hub-games-open") === "true") {
        return closePanel(el);
      } else {
        return openSheet(el);
      }
    }
    
  };
  el._gdcDrawerClick = drawerClick;
  el.addEventListener("click", drawerClick, {
        capture: true
      });
  var drawerKey = function ($$event) {
    if (!isDrawerMode()) {
      return ;
    }
    var key = $$event.key;
    if (key === "Escape" && DomEl$GameDataCore.data(el, "hub-games-open") === "true") {
      $$event.preventDefault();
      $$event.stopPropagation();
      closePanel(el);
      return focusTrigger(el);
    }
    if (!(key === "Enter" || key === " ")) {
      return ;
    }
    var target = $$event.target;
    if (target == null) {
      return ;
    }
    var match = target.closest("[data-nav-flyout-back]");
    if (match == null) {
      var match$1 = target.closest("[data-nav-flyout-trigger]");
      if (match$1 == null) {
        return ;
      }
      var match$2 = target.closest("[data-hub-games-hover-panel]");
      if (match$2 == null) {
        $$event.preventDefault();
        if (DomEl$GameDataCore.data(el, "hub-games-open") === "true") {
          return closePanel(el);
        } else {
          return openSheet(el);
        }
      } else {
        return ;
      }
    }
    $$event.preventDefault();
    closePanel(el);
    focusTrigger(el);
  };
  el._gdcDrawerKey = drawerKey;
  el.addEventListener("keydown", drawerKey);
}

function destroyed() {
  var self = this ;
  var el = self.el;
  var timer = el._gdcCloseTimer;
  if (timer !== undefined) {
    clearTimeout(Caml_option.valFromOption(timer));
  }
  var handler = el._gdcDrawerClick;
  if (handler !== undefined) {
    el.removeEventListener("click", handler, true);
  }
  var handler$1 = el._gdcDrawerKey;
  if (handler$1 !== undefined) {
    el.removeEventListener("keydown", handler$1);
  }
  closePanel(el);
}

var hubGamesHoverPanel = {
  mounted: mounted,
  destroyed: destroyed
};

var closeDelayMs = 150;

export {
  closeDelayMs ,
  isDrawerMode ,
  setPanelAria ,
  closePanel ,
  openPanel ,
  scheduleClose ,
  openSheet ,
  focusTrigger ,
  mounted ,
  destroyed ,
  hubGamesHoverPanel ,
}
/* mounted Not a pure module */
